/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Guess_Placeholder_CountryInputs */

const bn_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফ্রান্স, জাপান, ব্রাজিল...`)
};

const de_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankreich, Japan, Brasilien...`)
};

const el_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γαλλία, Ιαπωνία, Βραζιλία...`)
};

const en_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`France, Japan, Brazil...`)
};

const es_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francia, Japón, Brasil...`)
};

const fr_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`France, Japon, Brésil...`)
};

const hi_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़्रांस, जापान, ब्राज़ील...`)
};

const hu_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franciaország, Japán, Brazília...`)
};

const id_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prancis, Jepang, Brasil...`)
};

const it_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francia, Giappone, Brasile...`)
};

const ja_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フランス、日本、ブラジル…`)
};

const ko_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프랑스, 일본, 브라질...`)
};

const nl_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankrijk, Japan, Brazilië...`)
};

const pl_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francja, Japonia, Brazylia...`)
};

const pt_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`França, Japão, Brasil...`)
};

const ru_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Франция, Япония, Бразилия...`)
};

const sv_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankrike, Japan, Brasilien...`)
};

const tr_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fransa, Japonya, Brezilya...`)
};

const uk_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Франція, Японія, Бразилія...`)
};

const vi_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pháp, Nhật Bản, Braxin...`)
};

const zh_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法国、日本、巴西...`)
};

const zh_hant_game_guess_placeholder_country = /** @type {(inputs: Game_Guess_Placeholder_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法國、日本、巴西...`)
};

/**
* | output |
* | --- |
* | "France, Japan, Brazil..." |
*
* @param {Game_Guess_Placeholder_CountryInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_guess_placeholder_country = /** @type {((inputs?: Game_Guess_Placeholder_CountryInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Guess_Placeholder_CountryInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_guess_placeholder_country(inputs)
	if (locale === "de") return de_game_guess_placeholder_country(inputs)
	if (locale === "el") return el_game_guess_placeholder_country(inputs)
	if (locale === "en") return en_game_guess_placeholder_country(inputs)
	if (locale === "es") return es_game_guess_placeholder_country(inputs)
	if (locale === "fr") return fr_game_guess_placeholder_country(inputs)
	if (locale === "hi") return hi_game_guess_placeholder_country(inputs)
	if (locale === "hu") return hu_game_guess_placeholder_country(inputs)
	if (locale === "id") return id_game_guess_placeholder_country(inputs)
	if (locale === "it") return it_game_guess_placeholder_country(inputs)
	if (locale === "ja") return ja_game_guess_placeholder_country(inputs)
	if (locale === "ko") return ko_game_guess_placeholder_country(inputs)
	if (locale === "nl") return nl_game_guess_placeholder_country(inputs)
	if (locale === "pl") return pl_game_guess_placeholder_country(inputs)
	if (locale === "pt") return pt_game_guess_placeholder_country(inputs)
	if (locale === "ru") return ru_game_guess_placeholder_country(inputs)
	if (locale === "sv") return sv_game_guess_placeholder_country(inputs)
	if (locale === "tr") return tr_game_guess_placeholder_country(inputs)
	if (locale === "uk") return uk_game_guess_placeholder_country(inputs)
	if (locale === "vi") return vi_game_guess_placeholder_country(inputs)
	if (locale === "zh") return zh_game_guess_placeholder_country(inputs)
	return zh_hant_game_guess_placeholder_country(inputs)
});